module.exports = __webpack_public_path__ + "img/stock0.067dfaf6.png";